import {
  isPlatformBrowser,
  LocationStrategy,
} from '@angular/common';
import {
  Component,
  DestroyRef,
  inject,
  Inject,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import {
  ActivatedRoute,
  Router,
} from '@angular/router';

// import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { Hotel_Default_ErrMsg } from 'app/lookup-config';
import { componentDestroyed } from 'ng2-rx-componentdestroyed';
import { NgxSpinnerService } from 'ngx-spinner';
import {
  first,
  share,
  takeUntil,
} from 'rxjs/operators';
import Swal from 'sweetalert2';

import { FlightBooking } from '@models/flight-booking-model';
import {
  UntilDestroy,
  untilDestroyed,
} from '@ngneat/until-destroy';
import { ActivitesService } from '@services/activites.service';
import { CommonService } from '@services/common.service';
import { FlightBookService } from '@services/flight-book.service';
import { HotelService } from '@services/hotel-service.service';
import { SharedService } from '@services/shared.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@UntilDestroy()
@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styles: [''],
  providers: [],
})
export class PaymentsComponent implements OnInit {
  queryParamsInfo: any;
  hotelbookinginformation: any;

  //flight variables
  selectedFlight;
  source;
  destination;
  sellStatus;
  segmentsCnt: any;
  bookingDetails;
  searchparams;
  billingInfo;
  paypalResponseObject: any;
  currentCurrency: string;
  hotelImg: string;
  latitude: any;
  longitude: any;
  baseFarePerNight: any;
  isLoading: boolean = false;
  cancellationPolicy: any;
  roomName: any;
  emailId: any;
  phoneNum: any;
  rating: any;
  module: string;
  userObj: any;
  tempReferenceId: any;

  // fromConversionCurrencyCode,
  //     toConversionCurrencyCode: this.paypalInfo.totalPrice.toConversionCurrencyCode,
  //     fromConversionRate: this.paypalInfo.totalPrice.fromConversionRate,
  //     toConversionRate: this.paypalInfo.totalPrice.toConversionRate


  paypalInfo: {
    pgChargedAmount: string, pgChargedCurrency: string, pgConvertionRate: string, totalPrice: {
      total: any, couponTotal: any, convertedcurrency: any, convertedAmount: any, conversionRate: any, fromConversionCurrencyCode: any,
      toConversionCurrencyCode: any, fromConversionRate: any, toConversionRate: any
    }, selectedOfferItemGroup: any,
    newRequestId: any, uniqueOfferReferenceID: any, shoppingResponseRefID: any, selectOfferItemGroup: any, shoppingResponseID: any
  } = null;


  postAncilaryPaypalDetails: any = {};
  requestId: any;
  private destroyRef = inject(DestroyRef);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sharedService: SharedService,
    private flightBook: FlightBookService,
    private hotelservice: HotelService,
    private spinner: NgxSpinnerService,
    private actservice: ActivitesService,
    private shared: SharedService,
    // private gtmService: GoogleTagManagerService,
    private commonService: CommonService, @Inject(PLATFORM_ID) private platformId, private location: LocationStrategy
  ) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      history.pushState(null, null, window.location.href);
      this.location.onPopState(() => {
        history.pushState(null, null, window.location.href);
      });
    }
  }
  ngOnInit() {
    this.sharedService.userDetailsParam
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((userDataObj) => {
        if (userDataObj != null && userDataObj != undefined) {
          console.log(userDataObj, "   Data ")
          if (userDataObj) {
            // console.log(typeof this.userobj, this.userobj);
            this.userObj = userDataObj;

          } else {

          }
        }
      });

      this.shared.tempReferenceID$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((refID) => {
        if (refID != null && refID != "" && refID != undefined) {
          this.tempReferenceId = refID;
        }
      });

    this.sharedService.papalBookingItemDetails$.subscribe((bookingDetails) => {
      if (bookingDetails) {
        this.hotelbookinginformation = bookingDetails;
        console.log(JSON.stringify(this.hotelbookinginformation));
      }
    });

    // Subscribing to request params
    this.sharedService.PaymentSearchParams$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((searchReq) => {
        console.log(searchReq);
        if (searchReq != null && searchReq != undefined) {
          this.searchparams = searchReq;
          console.log(JSON.stringify(this.searchparams));
        }
      });

    // Flight Shared Service

    this.sharedService.selectedItemDetailsParam$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((selectedFlight) => {
        if (selectedFlight != null && selectedFlight != undefined) {
          this.selectedFlight = selectedFlight;
          if (this.searchparams.tripType != 'MultiCity') {

            this.source = selectedFlight.deptsource;
            this.destination = selectedFlight.deptdestination;
          } else {
            this.source = selectedFlight[0].deptsource;
            this.destination = selectedFlight[0].deptdestination;
          }



          console.log(JSON.stringify(this.source, this.destination));
          console.log(JSON.stringify(this.selectedFlight));
        }
      });

    this.sharedService.sellStatus$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((sellStatus) => {
        if (sellStatus != null && sellStatus != undefined) {
          this.sellStatus = sellStatus;
        }
      });

    this.sharedService.segmentCount$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((segCnt) => {
        if (segCnt != null && segCnt != undefined) {
          this.segmentsCnt = segCnt;
        }
      });

    this.sharedService.bookingDetailsParam$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((bookDtls) => {

        if (bookDtls != null && bookDtls != undefined) {
          this.bookingDetails = bookDtls;
        }
      });

    this.sharedService.billingDetails$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((billingInfo) => {
        if (billingInfo != null && billingInfo != undefined) {
          this.billingInfo = billingInfo;
        }
      });


    this.sharedService.papalBookingItemDetails$.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((paypal_info) => {
        if (paypal_info != null && paypal_info != undefined) {
          this.paypalInfo = paypal_info;
        }
      })



    this.sharedService.postAncilaryPaypalDetailsParams$.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((paypal_info) => {
        if (paypal_info != null && paypal_info != undefined) {
          this.postAncilaryPaypalDetails = paypal_info;
        }
      })

    // Flight Shared Service End

    this.flightBook.BOOKINGSUCCESS.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((res) => {
      this.isLoading = false;

      if (res != null) {
        if (res.success) {

          let seatClass;
          if (this.searchparams.tripType != "MultiCity") {
            seatClass = this.selectedFlight.depflight.bookingSeatClass;
          } else {
            seatClass = this.selectedFlight[0].depflight.bookingSeatClass;
          }


          if (res.pendingAction == "false") {
            res['transactionId'] = this.paypalResponseObject.paymentId;
            res['seatClass'] = seatClass;

            this.sharedService.setBookingSuccess(res);
            this.router.navigate(['/voucher/success']);
          } else {
            if (res.pendingAction == "true") {
              res['seatClass'] = seatClass;

              this.shared.setBookingSuccess(res);
              this.router.navigate(['/pending-voucher/unconfirmed']);
            } else if (res.uiErrorMessage[0] == 'Seat Not Available') {
              Swal.fire({
                title: res.statusMessage[0] + ', please try other flights',
                confirmButtonText: 'Go back to Flights',
                allowOutsideClick: false,
              }).then(ok => {
                this.router.navigate(['/']);
              });
            } else if (res.uiErrorMessage[0] == 'PaymentGateWay Error') {
              this.clearStorage();
              Swal.fire({
                title: res.statusMessage[1],
                confirmButtonText: 'Please Try Again',
                allowOutsideClick: false,
              }).then(ok => {
              });
            }
          }
        } else {
          let finalMessage = [];
          if(res && res.messageInfo && res.messageInfo.uiErrorMessage){
            finalMessage = res.messageInfo.uiErrorMessage;
          }else{
            finalMessage = ["We could not able to complete your booking process at this time.",
              "Rest assured our team will be checking and resolve",
              "For reference please keep this ID with you"+ this.tempReferenceId + " "
              ]
          }

          let messageInfo = {
            displayMessage : finalMessage,
            errorMessage : res,
            tempReferenceId:this.tempReferenceId
          }
          this.shared.setErrorObjectInfo(messageInfo);

          // this.router.navigate(['error'], {
          //   queryParams: {
          //     module: 'FT',
          //     code: 'BOOK_ERR_FT',
          //     message: res.messageInfo != null ? JSON.stringify(res.messageInfo.uiErrorMessage) : '[]'
          //   }
          // });
        }
      }
    });

    this.flightBook.onFailure.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response) => {
        console.log(JSON.stringify(response), "  At On Failure ");
        if (response) {
          this.isLoading = false;
          if (response.exceptionSource == 'book') {
            let messageInfo = {
              displayMessage : ["We could not able to complete your booking process at this time.",
                                "Rest assured our team will be checking and resolve",
                                "For reference please keep this ID with you"+ this.tempReferenceId + " "
                                ],
              errorMessage : response,
              tempReferenceId:this.tempReferenceId
            }
            this.shared.setErrorObjectInfo(messageInfo);

            // this.router.navigate(['error'], {
            //   queryParams: {
            //     module: 'FT',
            //     code: 'BOOK_ERR_FT',
            //     message: [],
            //   },
            // });
          }
        }
      });

    this.flightBook.ancillaryPurchaseSuccess$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(status => {
      if (status != null && status != undefined) {
        console.log("== success status ==", status);
        this.isLoading = false;
        if (status.success) {
          this.shared.setPostBookSuccess(status);
          this.router.navigate(['/post-voucher/success']);
        } else {
          let finalMessage = [];
          if(status && status.messageInfo && status.messageInfo.uiErrorMessage){
            finalMessage = status.messageInfo.uiErrorMessage;
          }else{
            finalMessage = ["We could not able to complete your booking process at this time.",
              "Rest assured our team will be checking and resolve",
              "For reference please keep this ID with you"+ this.tempReferenceId + " "
              ]
          }

          let messageInfo = {
            displayMessage : finalMessage,
            errorMessage : status,
            tempReferenceId:this.tempReferenceId
          }
          this.shared.setErrorObjectInfo(messageInfo);


          // this.router.navigate(['error'], { queryParams: { 'module': 'FT', 'code': 'BOOK_ERR_FT', 'spr_code': status.statusMessage ? status.statusMessage[0] : "" } });
        }
      }
    });



    // this.hotelservice.hotelBookingSuccess
    //   .pipe(takeUntilDestroyed(this.destroyRef))
    //   .subscribe(
    //     (bookres) => {
    //       console.log('-- payment component response --', bookres);
    //       if (bookres.result != null && bookres.result != undefined) {
    //         if (
    //           bookres.result.result != null &&
    //           bookres.result.result != undefined
    //         ) {
    //           this.spinner.hide();
    //           bookres.result.result.hotelPhone = this.hotelbookinginformation.hotelPhone;
    //           bookres.result.result.roomName = this.hotelbookinginformation.roomName;
    //           bookres.result.result.emailId = this.hotelbookinginformation.emailId;
    //           bookres.result.result.phoneNum = this.hotelbookinginformation.phoneNum;
    //           bookres.result.result.rating = this.hotelbookinginformation.rating;
    //           // this.sharedService.setVoucherDtls(bookres.result.result);
    //           // this.sharedService.removeHotelDtls();
    //           this.commonService.insertHotelSuccessQueryParamsInfo({
    //             requestObj: JSON.stringify(bookres.result.result),
    //           });

    //           // this.router.navigate(['hotel-voucher'], {
    //           //   queryParams: {
    //           //     hotelImg: this.hotelImg,
    //           //     latitude: this.latitude,
    //           //     longitude: this.longitude,
    //           //     baseFarePerNight: this.baseFarePerNight,
    //           //     roomName: this.roomName,
    //           //     emailId: this.emailId,
    //           //     phoneNum: this.phoneNum,
    //           //     rating: this.rating,
    //           //   },
    //           // });
    //         } else {
    //           let msg = '';
    //           let resultObj = bookres.result;
    //           if (
    //             resultObj.messageInfo != undefined &&
    //             resultObj.messageInfo != null &&
    //             resultObj.messageInfo.errorCode != null
    //           ) {
    //             msg = resultObj.messageInfo.uiErrorMessage;
    //           } else if (
    //             resultObj.messageInfo != undefined &&
    //             resultObj.messageInfo != null &&
    //             resultObj.messageInfo.errorCode == null
    //           ) {
    //             msg = resultObj.messageInfo.uiWarningMessage;
    //           }
    //           msg = msg != null && msg != '' ? msg : Hotel_Default_ErrMsg;
    //           this.router.navigate(['hotel-error'], {
    //             queryParams: { error_msg: btoa(msg) },
    //           });
    //           // this.router.navigate(['error'], {
    //           //   queryParams: { module: 'HT', code: 'BOOK_ERR_HL' },
    //           // });
    //         }
    //       } else {
    //         this.router.navigate(['hotel-error'], {
    //           queryParams: { module: 'htl_bk', error_code: 'Book_Err_Info' },
    //         });
    //       }

    //       // }
    //     },
    //     (err) => {
    //       this.router.navigate(['hotel-error'], {
    //         queryParams: { module: 'htl_bk', error_code: 'Book_Err_Info' },
    //       });
    //     }
    //   );

    // this.sharedService.currenctCurrencyParam$.subscribe((curr) => {
    //   if (curr) {
    //     this.currentCurrency = curr;
    //   }
    // });

    this.shared.paymentCurrency$.subscribe((curr) => {
      if (curr) {
        this.currentCurrency = curr;
      }
    });


    this.hotelservice.onFailure.pipe(first()).subscribe((response) => {
      if (response != undefined && response != null) {
        if (response.exceptionSource == 'Booking_issue') {
          this.router.navigate(['hotel-error'], {
            queryParams: { module: 'htl_bk', error_code: 'Book_Err_Info' },
          });
        }
      }
    });

    this.commonService.HOTELCONFIRMATIONINSERTIONSUCCESS$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((response) => {
      if (response != null && response != undefined) {
        // this.sharedService.setHotelTravelRequest(response.result);
        this.router.navigate(['hotel-voucher'], {
          queryParams: {
            hotelImg: this.hotelImg,
            latitude: this.latitude,
            longitude: this.longitude,
            baseFarePerNight: this.baseFarePerNight,
            roomName: this.roomName,
            emailId: this.emailId,
            phoneNum: this.phoneNum,
            rating: this.rating,
            request: response.result
          },
        });
        this.isLoading = false;
      }
    });

    // this.actservice.onFailure
    //   .pipe(takeUntilDestroyed(this.destroyRef))
    //   .subscribe((response) => {
    //     if (response) {
    //       this.spinner.hide();

    //       if (response.exceptionSource == 'Booking_issue') {
    //         this.router.navigate(['error'], { queryParams: { module: 'SS' } });
    //       }
    //     }
    //   });



    this.commonService.ACTIVITYCONFIRMATIONINSERTIONSUCCESS$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      if (res && res.result) {
        this.spinner.hide();
        if (this.module === "SS") {
          this.router.navigate(["/activity-voucher"], { queryParams: { requestId: res.result } });
        }
      }
    });




    // this.actservice.BookingSuccess.pipe(
    //   takeUntil(componentDestroyed(this)),
    //   share()
    // ).subscribe((actRes) => {
    //   this.spinner.hide();
    //   this.isLoading = false;
    //   console.log('---  activity bookingresponse ---', JSON.stringify(actRes));
    //   if (actRes.data != null && actRes.data != undefined) {
    //     this.sharedService.removeActivityDtls();
    //     if (actRes.data.bookingStatus.status != 5) {
    //       console.log('navigate to voucher' + JSON.stringify(actRes));





    //       let currentGObject = {
    //         'event': 'purchase',
    //         'ecommerce': {
    //           'currencyCode': this.currentCurrency,
    //           currency: this.currentCurrency,
    //           'purchase': {
    //             actionField: {
    //               affiliation: "YourTravelBooking Activity Booking Success",
    //               id: this.hotelbookinginformation.booking.tempReferenceId,
    //               tax: 0,
    //               revenue: this.hotelbookinginformation.booking.amount,
    //               currency: this.currentCurrency,
    //               currencyCode: this.currentCurrency,
    //             },
    //             'products': [{
    //               'name': this.hotelbookinginformation.booking.productName,         // Name or ID is required.
    //               'id': this.hotelbookinginformation.tempBookingId,
    //               'price': this.hotelbookinginformation.booking.paymentDetails.amount,
    //               'brand': 'Activity Bookings',
    //               'category': this.hotelbookinginformation.booking.items[0].traveldate,
    //               'quantity': 1
    //             }]
    //           }
    //         }
    //       };
    //       this.gtmService.pushTag(currentGObject);







    //       actRes.couponCharges = this.hotelbookinginformation.booking.paymentDetails.couponCharges;
    //       actRes.cancellationPolicy = this.hotelbookinginformation.booking.cancellationPolicy;
    //       //this.sharedService.setVoucherDtls(actRes);
    //       // this.router.navigate(['activity-voucher']);


    //       let queryparamsData = {
    //         bookingData: actRes,
    //         fromBooking: true,
    //         IscomingfromPI: false,
    //         bookingSuccessParams: this.hotelbookinginformation
    //       };
    //       this.commonService.insertActivitySuccessQueryParamsInfo({ requestObj: JSON.stringify(queryparamsData) });

    //       // this.sharedService.setActivityPaymentSuccessParams(queryparamsData);
    //       // this.router.navigate(["activity-voucher"]);

    //     } else {
    //       this.router.navigate(['error'], {
    //         queryParams: { module: 'SS', code: 'BOOK_ERR_SS' },
    //       });
    //     }
    //   } else {
    //     this.router.navigate(['error'], {
    //       queryParams: { module: 'SS', code: 'BOOK_ERR_SS' },
    //     });
    //   }
    // });
  }

  bookAncilaryFlightFlight() {
    this.isLoading = true;

    let postAncilaryObj;

    postAncilaryObj = this.postAncilaryPaypalDetails;

    postAncilaryObj.bookingPayment.payPalPaymentID = this.paypalResponseObject.paymentId;
    postAncilaryObj.bookingPayment.payerID = this.paypalResponseObject.PayerID;
    postAncilaryObj.bookingPayment.pgChargedAmount = this.paypalInfo.pgChargedAmount;
    postAncilaryObj.bookingPayment.pgChargedCurrency = this.paypalInfo.pgChargedCurrency;
    postAncilaryObj.bookingPayment.pgConvertionRate = this.paypalInfo.pgConvertionRate;

    postAncilaryObj.bookingPayment.conversionCurrencyCode = this.paypalInfo.totalPrice.convertedcurrency;
    postAncilaryObj.bookingPayment.conversionValue = this.paypalInfo.totalPrice.convertedAmount;

    postAncilaryObj.bookingPayment.conversionRate = this.paypalInfo.totalPrice.conversionRate;

    postAncilaryObj.bookingPayment.fromConversionCurrencyCode = this.paypalInfo.totalPrice.fromConversionCurrencyCode;
    postAncilaryObj.bookingPayment.toConversionCurrencyCode = this.paypalInfo.totalPrice.toConversionCurrencyCode;
    postAncilaryObj.bookingPayment.fromConversionRate = this.paypalInfo.totalPrice.fromConversionRate;
    postAncilaryObj.bookingPayment.toConversionRate = this.paypalInfo.totalPrice.toConversionRate;



    console.log(JSON.stringify(postAncilaryObj));
    this.flightBook.bookPostAncillary(postAncilaryObj);

  }

  postPaymentBooking() {
    this.spinner.show();
    let bookingRequest = {
      "postBookingPaymentID": this.hotelbookinginformation.postBookingPaymentID,
      "ytbPaymentTotalCharge": this.hotelbookinginformation.paymentGatewayAmount,
      "paymentCurrencyCode": this.hotelbookinginformation.paymentCurrency,
      "tempBookingNo": this.hotelbookinginformation.bookingID,
      "bookingID": this.hotelbookinginformation.bookingID,
      paymentId: this.paypalResponseObject.paymentId,
      payerID: this.paypalResponseObject.PayerID,
      pgChargedAmount: this.hotelbookinginformation.pgChargedAmount,
      pgChargedCurrency: this.hotelbookinginformation.pgChargedCurrency,
      pgConvertionRate: this.hotelbookinginformation.pgConvertionRate,
      "userAddresses": this.hotelbookinginformation.userAddresses
    };

    console.log(bookingRequest, JSON.stringify(bookingRequest));
    this.spinner.show();
    this.commonService.makePostBookingPaymentDetails(bookingRequest);

    this.commonService.PostBookingSuccess$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      console.log(res, JSON.stringify(res), "     After MakePayment ");
      this.spinner.hide();
      Swal.fire({
        title: "Payment Successfull",
        allowOutsideClick: false,
        confirmButtonText: "Proceed To Home Page",
        confirmButtonColor: "green"
      }).then((ok) => {
        this.router.navigate(['']);
      });
    });


  }





  ngAfterContentInit() {
    this.route.queryParams.subscribe((paypalRes) => {
      if (paypalRes) {
        this.requestId = paypalRes.requestId;
        console.log(JSON.stringify(paypalRes));
        if (paypalRes.type === 'success') {
          this.paypalResponseObject = paypalRes;
          this.module = paypalRes.module;
          if (paypalRes.module == 'FT' && !paypalRes.isPostAncilary) {
            this.bookFlight();
          } else if (paypalRes.module == 'FT' && paypalRes.isPostAncilary) {
            this.bookAncilaryFlightFlight();
          }
          else if (paypalRes.module == 'HT') {
            this.hotelImg = paypalRes['hotelImg'];
            (this.latitude = paypalRes['latitude']),
              (this.longitude = paypalRes['longitude']),
              (this.baseFarePerNight = paypalRes['baseFarePerNight']);
            this.cancellationPolicy = paypalRes['cancellationPolicy'];
            this.roomName = paypalRes['roomName'];
            this.emailId = paypalRes['emailId'];
            this.phoneNum = paypalRes['phoneNum'];
            this.rating = paypalRes['rating'];
            this.hotelbookinginformation.bookingData.transactionRequest.payerId =
              paypalRes.PayerID;
            this.hotelbookinginformation.bookingData.transactionRequest.paymentId =
              paypalRes.paymentId;
            var countryiso2 = JSON.parse(localStorage.getItem('geolocation'));
            this.hotelbookinginformation.bookingData.transactionRequest.bookingCountryISO2 =
              countryiso2.countryCode;
            this.hotelbooking();
          }
          else if (paypalRes.module == 'SS') {
            this.hotelbookinginformation.booking.payPalPaymentID =
              paypalRes.paymentId;
            this.hotelbookinginformation.booking.PayerID = paypalRes.PayerID;
            console.log(
              'payment responseeeee' +
              JSON.stringify(this.hotelbookinginformation)
            );
            this.activityBooking();
          }
          else if (paypalRes.module == 'PB') {
            this.hotelbookinginformation.payPalPaymentID =
              paypalRes.paymentId;
            this.hotelbookinginformation.PayerID = paypalRes.PayerID;

            this.postPaymentBooking();
          }
        } else if (paypalRes.type === 'failure') {
          if (paypalRes.module == 'SS') {
            let params = new URLSearchParams();
            for (let key in this.hotelbookinginformation.queryparamsData) {
              params.set(
                key,
                this.hotelbookinginformation.queryparamsData[key]
              );
            }

            this.router.navigateByUrl(
              'activity-payment?paymentstatus=failed&requestId=' + paypalRes.requestId + '&' + params.toString()
            );
          }


          else if (paypalRes.module == 'HT') {
            let value = btoa('failed');
            this.router.navigateByUrl('hotel-Payment?paymentstatus=' + value);
          }


          else if (paypalRes.module == 'FT') {
            let value = 'failed';
            console.log(('book/flight?paymentstatus=' + value + '&requestId=' + paypalRes.requestId));
            this.router.navigateByUrl('book/flight?paymentstatus=' + value + '&requestId=' + paypalRes.requestId);
          }



        }
      }
    });
  }

  hotelbooking() {
    this.spinner.show();
    this.isLoading = true;
    this.hotelservice.HotelBookRequest(
      this.hotelbookinginformation.bookingData
    );
  }

  bookFlight() {
    this.isLoading = true;
    let bookModel = new FlightBooking();
    let sellResponse = {};
    let flightObj = {};
    let depdate: string;
    let sourceCtry: string;
    let destinationCtry: string;
    let carrier: string;
    let price: number;
    let fareDetails;
    let payObj = {};

    let total = this.calculateTotalPrice();


    let couponInfoObj;

    console.log(JSON.stringify(this.selectedFlight))
    if (this.searchparams.tripType != 'MultiCity') {
      depdate = this.selectedFlight.depflight.flightDetails[0].dateOfDeparture;
      sourceCtry = this.selectedFlight.deptsource.country_name;
      destinationCtry = this.selectedFlight.deptdestination.country_name;
      carrier = this.selectedFlight.depflight.flightDetails[0].marketingCarrier;
      price = this.selectedFlight.price;
      if (this.searchparams.tripType == 'OneWay') {
        fareDetails = this.selectedFlight.depflight.fareDetails;
      } else {
        fareDetails = this.selectedFlight.arrivalflight.fareDetails;
      }
      couponInfoObj = this.selectedFlight.couponObj;


    }

    if (this.searchparams.tripType == 'MultiCity') {
      depdate = this.selectedFlight[0].depflight.flightDetails[0]
        .dateOfDeparture;
      sourceCtry = this.selectedFlight; //need to verify
      destinationCtry = this.selectedFlight; // need to verify
      carrier = this.selectedFlight[0].depflight.flightDetails[0]
        .marketingCarrier;
      price = this.selectedFlight[
        this.selectedFlight.length - 1
      ].price.toString();
      fareDetails = this.selectedFlight[this.selectedFlight.length - 1]
        .depflight.fareDetails;

      couponInfoObj = this.selectedFlight[0].couponObj;


    }

    total += fareDetails.totalFareAmount;

    sellResponse['sellStatus'] = this.sellStatus;
    flightObj['flightInfo'] = {
      departureDate: depdate,
      carrier: carrier,
      totalAmtPayable: this.paypalInfo.totalPrice.total,
      segmentsCnt: this.segmentsCnt,
      sourceCtry: sourceCtry,
      destinationCtry: destinationCtry,
      flghttripDtls: this.searchparams,
      fareDetails: fareDetails,
      currency: this.currentCurrency,
      couponObj: couponInfoObj,
      totalAmtPayableWhenCouponApplied: this.paypalInfo.totalPrice.couponTotal,
      paymentCards: this.bookingDetails.paymentCards,
      convertedCurrency: this.paypalInfo.totalPrice.convertedcurrency,
      convertedAmount: this.paypalInfo.totalPrice.convertedAmount,
      conversionRate: this.paypalInfo.totalPrice.conversionRate,
      fromConversionCurrencyCode: this.paypalInfo.totalPrice.fromConversionCurrencyCode,
      toConversionCurrencyCode: this.paypalInfo.totalPrice.toConversionCurrencyCode,
      fromConversionRate: this.paypalInfo.totalPrice.fromConversionRate,
      toConversionRate: this.paypalInfo.totalPrice.toConversionRate,
      newRequestId: this.paypalInfo.newRequestId,
      selectedOfferItemGroup: this.paypalInfo.selectedOfferItemGroup,
      uniqueOfferReferenceID: this.paypalInfo.uniqueOfferReferenceID,
      shoppingResponseRefID: this.paypalInfo.shoppingResponseRefID
    };







    payObj['paymentMethod'] = {
      paypal: {
        paymentId: this.paypalResponseObject.paymentId,
        payerID: this.paypalResponseObject.PayerID,
        pgChargedAmount: this.paypalInfo.pgChargedAmount,
        pgChargedCurrency: this.paypalInfo.pgChargedCurrency,
        pgConvertionRate: this.paypalInfo.pgConvertionRate,
      },
    };
    console.log(JSON.stringify(flightObj), " flightObj Object");
    console.log(JSON.stringify(payObj), " payObj Object");

    console.log(JSON.stringify(this.bookingDetails)), " this.bookingDetails Object";

    let bookingObject = Object.assign(this.bookingDetails, flightObj);


    console.log(JSON.stringify(bookingObject), " Book Object");

    let flightDetailsObj = { flightDetails: this.selectedFlight };


    console.log(JSON.stringify(flightDetailsObj), " Flight Details  Obj");

    let flightDetails = Object.assign(bookingObject, flightDetailsObj);

    console.log(JSON.stringify(flightDetails), " flightDetails");


    let billingObj = { billingaddress: this.billingInfo, addressType: this.billingInfo.addressType };

    console.log(JSON.stringify(billingObj), " billingObj Obj");

    let completeBookObject = Object.assign(flightDetails, billingObj);


    console.log(JSON.stringify(completeBookObject), " Complete  Book Obj");


    let finalBookObj = Object.assign(completeBookObject, payObj);

    console.log(JSON.stringify(finalBookObj), "   Final Book Obj");



    // let specialServiceObj = {
    //   meals: '',
    //   wheelchairs: '',
    // };



    console.log(JSON.stringify(this.selectedFlight.specialServiceObj), "   Special Service Obj");

    let bookObj: FlightBooking = bookModel.prepareFlightBooking(
      bookModel,
      finalBookObj,
      this.selectedFlight.specialServiceObj,
      [{ "adultIndex": 0, "infantIndex": 0 }],
      this.bookingDetails.originDestinationOptions,
      this.userObj,
      ""
    );



    let ytbPaymentTotalCharge = parseFloat(fareDetails.totalFareAmount.toString().match(/^-?\d+(?:\.\d{0,3})?/)[0]);
    let ytbPaymentTotalTax = parseFloat(fareDetails.totalTaxAmount.toString().match(/^-?\d+(?:\.\d{0,3})?/)[0]);



    let currentGObject = {
      'event': 'purchase',
      'ecommerce': {
        'currencyCode': this.currentCurrency,
        currency: this.currentCurrency,
        'purchase': {
          actionField: {
            affiliation: "YourTravelBooking Flight Booking Success",
            id: finalBookObj.tempReferenceIdNo,
            tax: ytbPaymentTotalTax,
            revenue: this.paypalInfo.totalPrice.total,
            currency: this.currentCurrency,
            currencyCode: this.currentCurrency,
          },
          'products': [{
            'name': this.source.airportName + ' to ' + this.destination.airportName,         // Name or ID is required.
            'id': this.requestId,
            'price': this.paypalInfo.totalPrice.total,
            'brand': 'Flight Bookings',
            'category': this.searchparams.tripType,
            'quantity': 1
          }]
        }
      }
    };
    // this.gtmService.pushTag(currentGObject);



    bookObj.selectedFlightObject = JSON.stringify(this.selectedFlight);

    bookObj.additionalBookingDetails.sessionId = this.requestId;

    // bookObj.selectedFlightObject = this.selectedFlight;

    console.log(JSON.stringify(bookObj), "   Book Obj");
    this.flightBook.bookFlight(bookObj);



    // this.clearStorage();
  }




  activityBooking() {
    this.spinner.show();
    this.isLoading = true;
    this.sharedService.setBookingSuccess(this.hotelbookinginformation);
    this.actservice.activitesBookingrequest(this.hotelbookinginformation);
  }


  clearStorage() {
    localStorage.removeItem('bookingDetails');
  }

  calculateTotalPrice() {
    let psgrs = this.bookingDetails.passengers[0];
    let total = 0.00;

    for (let adt of psgrs.adultpsgrs) {
      for (let spl of adt.specialservices) {
        if (spl.seatPrice > 0) {
          total += spl.seatPrice;
        }
      }

      if (adt.ancillaryServices != null) {
        for (let ancl of adt.ancillaryServices) {
          if (ancl.ancillaryPrice > 0) {
            total += ancl.ancillaryPrice;
          }
        }
      }

    }

    for (let chd of psgrs.childpsgrs) {
      for (let spl of chd.specialservices) {
        if (spl.seatPrice > 0) {
          total += spl.seatPrice;
        }
      }

      if (chd.ancillaryServices != null) {
        for (let ancl of chd.ancillaryServices) {
          if (ancl.ancillaryPrice > 0) {
            total += ancl.ancillaryPrice;
          }
        }
      }
    }

    for (let inf of psgrs.infantpsgrs) {
      for (let spl of inf.specialservices) {
        if (spl.seatPrice > 0) {
          total += spl.seatPrice;
        }
      }

      if (inf.ancillaryServices != null) {
        for (let ancl of inf.ancillaryServices) {
          if (ancl.ancillaryPrice > 0) {
            total += ancl.ancillaryPrice;
          }
        }
      }
    }

    return total;
  }

  /**
   * This function is used to destroy services usage
   */
  ngOnDestroy() {
    this.hotelservice.dispose();
    this.flightBook.dispose();
  }
}
